import { AuthProvider } from 'react-admin';


export const authProvider: AuthProvider = {
    login: ({ username, password }) =>  {
        var bodyFormData =  new URLSearchParams();
        bodyFormData.append('username', username);
        bodyFormData.append('password', password);


        return Backendless.UserService.login<any>( username, password, true )
        .then( function( loggedInUser ) {
            console.log(loggedInUser);
            let auth = {
                id : loggedInUser.objectId,
                username: loggedInUser.username,
                email: loggedInUser.email,
                token: loggedInUser["user-token"],
                loggedInUser: loggedInUser
            }
            localStorage.setItem('auth', JSON.stringify(auth));
        })
        .catch( function( error ) {
            throw new Error('Network error')
        });


        /*
        const request = new Request('https://demo.leadingedge.ro/crm2020r1/custompages/leadingedge/SelfServiceAPiCore/users/authenticate', {
            method: 'POST',
            //body: bodyFormData,
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),            
        });


        return fetch(request)
            .then(response => {
               
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(auth => {
                localStorage.setItem('auth', JSON.stringify(auth));
            })
            .catch(() => {
                throw new Error('Network error')
            });
            */
    },
    logout: () => {
        localStorage.removeItem('auth');
        return Promise.resolve();
    },
    getIdentity: () => {
        try {            
            const { id, username, email, loggedInUser} = JSON.parse(localStorage.getItem('auth') || "");
            return Promise.resolve({ id, username, email, loggedInUser});
        } catch (error) {
            return Promise.reject(error);
        }
    },
    checkError:  (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('auth');
            return Promise.reject({ redirectTo: '/unauthorized', logoutUser: false });
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () =>
        localStorage.getItem('auth') ? Promise.resolve() : Promise.reject({ message: 'login.required' }),
    getPermissions: () => Promise.reject('Unknown method')
};
